import { ApiEndpointI, listaEndpointsPlanes } from "./listaEndpointsPlanes";

export type ApiID = "planes-estudio" | "establecimientos" | "infraestructura";

export interface ApiI {
  id: ApiID;
  titulo: string;
  swaggerDocs?: string;
  descripcion: string;
  listaEndpoints: ApiEndpointI[];
  disabled?: boolean;
}

const APP_API = window.configs.REACT_APP_API;

export const listaApis: ApiI[] = [
  {
    id: "planes-estudio",
    titulo: "API: Plan de estudio",
    descripcion:
      "Utiliza esta API para integrar datos de las resoluciones, los planes de estudio y el diseño curricular registrados en la plataforma.",
    listaEndpoints: listaEndpointsPlanes,
    swaggerDocs: APP_API + "api-docs#/",
  },
  {
    id: "establecimientos",
    titulo: "API: Establecimientos",
    descripcion: "Proximamente.",
    listaEndpoints: [],
    disabled: true,
  },
  {
    id: "infraestructura",
    titulo: "API: Infraestructura",
    descripcion: "Proximamente.",
    listaEndpoints: [],
    disabled: true,
  },
];
